import StudentSuccessStoriesComponents from "../components/StudentSuccessStoriesComponents"

function studentSuccessStories() {
    return (
        <>
            <StudentSuccessStoriesComponents/>
        </>
    )
}

export default studentSuccessStories
